exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".book img[data-v-15b71860]{width:100%;height:100%}.book p[data-v-15b71860]{position:absolute;bottom:0;width:100%;text-align:center;height:50px;font-size:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-15b71860","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 18
// module chunks = 0